import { DestroyRef, inject, Injectable } from '@angular/core';
import { AuthFacade } from '@lentau/auth/store';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserFacade } from '@lentau/profile/store/user/user.facade';
import { ProfileCacheService } from './profile-cache.service';
import { UserAuthorizeType } from '@lentau/auth/shared/enums';
import { UserProfile } from 'angular-api-gateway/v1/model/userProfile';

@Injectable({ providedIn: 'root' })
export class ProfileCacheUpdateService {
  private userFacade: UserFacade = inject(UserFacade);
  private destroyRef: DestroyRef = inject(DestroyRef);
  private authFacade: AuthFacade = inject(AuthFacade);
  private profileCacheService: ProfileCacheService = inject(ProfileCacheService);

  public updateProfileIds(): void {
    // обновляем кэш если пользователь не авторизован
    this.authFacade.userAuthorizeType$
      .pipe(
        filter(Boolean),
        filter((value: UserAuthorizeType) => value === UserAuthorizeType.GUEST),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.profileCacheService.deleteCache();
      });

    // обновляем кэш по данным при получении апи
    this.userFacade.isLoaded$.pipe(filter(Boolean), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      const userInfo: UserProfile = this.userFacade.user();
      this.profileCacheService.updateCacheProfileIds(userInfo);
    });
  }
}
